<template>
  <div class="grid loader">
    <div class="col text-center loader-content">
      <lottie-player
        ref="spinnerLottieRef"
        :src="LoaderSpm"
        speed="1"
        direction="1"
        mode="normal"
        loop
        autoplay
        style="width: 400px; height: 400px;"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onBeforeUnmount } from 'vue';
import LoaderSpm from '@/assets/lottie/Animation.json';
// eslint-disable-next-line import/extensions
import '@/assets/js/lottie-player.js';

export default defineComponent({
  name: 'TheSpinner',

  setup() {
    const spinnerLottieRef = ref();

    onBeforeUnmount(() => {
      if (spinnerLottieRef.value) {
        spinnerLottieRef.value.destroy();
      }
    });

    return {
      LoaderSpm,
      spinnerLottieRef,
    };
  },
});
</script>

<style scoped lang="scss">
.loader {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  margin: 0;
  width: 100%;
  height: 100%;
  background: $loaderBackgroundColor;
  opacity: 0.8;
  z-index: 10000000;
}

.loader-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
